// ─── GBCOSPACK — QuotationHtmlDocument ───────────────────────────────────────
// PRODUCTION component for HTML quotation rendering.
// Used by: Admin Template Studio (preview) + future Customer document view.
// DO NOT duplicate this component — it is the single source of truth for HTML.

import type { QuotationDocumentData } from '@/quotation/document/types';
import HtmlDocHeader from './HtmlDocHeader';
import HtmlDocParties from './HtmlDocParties';
import HtmlDocItems from './HtmlDocItems';
import HtmlDocTotals from './HtmlDocTotals';
import HtmlDocTerms from './HtmlDocTerms';

interface Props {
  data: QuotationDocumentData;
}

export default function QuotationHtmlDocument({ data }: Props) {
  return (
    <div className="mx-auto w-full max-w-[1160px]">
      {/* Document surface — plain white sheet, no card chrome */}
      <div className="bg-white">
        <HtmlDocHeader data={data} />
        <HtmlDocParties data={data} />
        <HtmlDocItems data={data} />
        <HtmlDocTotals data={data} />
        <HtmlDocTerms data={data} />

        {/* Footer disclaimer */}
        <div className="px-8 md:px-12 py-7 border-t border-neutral-200">
          <p className="text-xs text-neutral-400 text-center leading-relaxed">
            {data.documentType === 'preliminary_quote'
              ? 'This preliminary quotation is for reference purposes only. Freight, insurance, taxes and customs duties are excluded unless otherwise stated.'
              : 'This Final Offer is commercially binding upon written acceptance within the validity period.'}
          </p>
        </div>
      </div>
    </div>
  );
}